var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BCard, BCardHeader, BCardBody } from 'bootstrap-vue';
import { getVisualisationUrl } from 'ts/modules/frameDesigner';
let FrameDesignOption = class FrameDesignOption extends Vue {
    get description() {
        if (this.frameSize) {
            return `${this.frameSize.name} to fit ${this.itemSize.name} item`;
        }
        return `${this.itemSize.name} (No Mount)`;
    }
    get rebateSize() {
        if (this.frameSize) {
            return {
                width: Math.min(this.frameSize.width, this.frameSize.length) + 3,
                length: Math.max(this.frameSize.width, this.frameSize.length) + 3
            };
        }
        return {
            width: Math.min(this.itemSize.width, this.itemSize.length) + 3,
            length: Math.max(this.itemSize.width, this.itemSize.length) + 3
        };
    }
    get apertureSize() {
        return {
            width: Math.min(this.itemSize.width, this.itemSize.length) - 6,
            length: Math.max(this.itemSize.width, this.itemSize.length) - 6
        };
    }
    get mountBorders() {
        if (this.frameSize) {
            const yBorder = ((this.rebateSize.length - this.apertureSize.length) - 3) / 2;
            const xBorder = ((this.rebateSize.width - this.apertureSize.width) - 3) / 2;
            return {
                type: 'single',
                top: this.mount,
                bottom: null,
                reveal: 0,
                borders: {
                    top: yBorder,
                    bottom: yBorder,
                    left: xBorder,
                    right: xBorder
                }
            };
        }
        return {
            type: 'none',
            top: null,
            bottom: null,
            reveal: 0,
            borders: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }
        };
    }
    get imgSrc() {
        return getVisualisationUrl(this.lengthSku, this.rebateSize, this.apertureSize, this.mountBorders, true, null, 1);
    }
    get altText() {
        return '#';
    }
};
__decorate([
    Prop({ type: Object, required: false, default: null })
], FrameDesignOption.prototype, "frameSize", void 0);
__decorate([
    Prop(Object)
], FrameDesignOption.prototype, "itemSize", void 0);
__decorate([
    Prop(String)
], FrameDesignOption.prototype, "lengthSku", void 0);
__decorate([
    Prop(Object)
], FrameDesignOption.prototype, "mount", void 0);
__decorate([
    Prop(String)
], FrameDesignOption.prototype, "fromPrice", void 0);
__decorate([
    Prop(Boolean)
], FrameDesignOption.prototype, "selected", void 0);
FrameDesignOption = __decorate([
    Component({
        components: {
            BCard, BCardHeader, BCardBody
        }
    })
], FrameDesignOption);
export default FrameDesignOption;
